import React from 'react';

/** Erişilebilir aç/kapa anahtarı. */
export const Switch: React.FC<{
  checked: boolean;
  onChange: (next: boolean) => void;
  label: string;
  disabled?: boolean;
}> = ({ checked, onChange, label, disabled }) => (
  <button
    type="button"
    role="switch"
    aria-checked={checked}
    aria-label={label}
    disabled={disabled}
    onClick={() => onChange(!checked)}
    className={`relative w-10 h-[22px] rounded-full transition-colors shrink-0 disabled:opacity-50 ${
      checked ? 'bg-[#1DA4BA]' : 'bg-neutral-600'
    }`}
  >
    <span
      className={`absolute top-[3px] w-4 h-4 rounded-full bg-white shadow-sm transition-all ${
        checked ? 'left-[21px]' : 'left-[3px]'
      }`}
    />
  </button>
);
